import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const DiplomaComputerEngineeringCoursePage: React.FC = () => {
  const courseData = {
    title: "Diploma in Computer Engineering",
    shortName: "DCE",
    duration: "3 years",
    description: "Technical program covering computer programming, networking, and software development",
    overview: "Diploma in Computer Engineering is a 3-year technical program that provides comprehensive knowledge of computer programming, software development, networking, and database management. This course combines theoretical concepts with practical lab sessions and projects, preparing students for careers in IT industry, software development, and system administration.",
    eligibility: [
      "10th pass from recognized board",
      "Minimum 50% marks in 10th (45% for SC/ST)", 
      "Mathematics and Science as compulsory subjects",
      "Basic computer knowledge preferred"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Engineering Mathematics",
          "Computer Fundamentals",
          "Programming in C",
          "Digital Electronics",
          "Computer Graphics",
          "Communication Skills"
        ]
      },
      {
        year: 2,
        subjects: [
          "Data Structures",
          "Object Oriented Programming",
          "Database Management Systems",
          "Computer Networks",
          "Web Development",
          "Operating Systems"
        ]
      },
      {
        year: 3,
        subjects: [
          "Software Engineering",
          "Mobile Application Development",
          "System Administration",
          "Cyber Security",
          "Project Management",
          "Industrial Training & Project"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Software Developer",
        "Web Developer",
        "System Administrator",
        "Network Technician",
        "Database Administrator",
        "Technical Support Engineer",
        "Junior Programmer",
        "Quality Assurance Tester",
        "IT Helpdesk Support",
        "Computer Hardware Technician"
      ],
      industries: [
        "Software Development",
        "IT Services",
        "Banking & Finance IT",
        "E-commerce Companies",
        "Government IT Departments",
        "Educational Institutions",
        "Healthcare IT",
        "Telecommunications",
        "Manufacturing IT",
        "Startups & SMEs"
      ],
      averageSalary: "₹3-6 LPA (Fresher), ₹8-20 LPA (Experienced)",
      topRecruiters: [
        "TCS, Infosys, Wipro",
        "Tech Mahindra, HCL",
        "Accenture, IBM",
        "Local Software Companies",
        "Banks & Financial Institutions",
        "Government IT Departments"
      ]
    },

    admissionProcess: [
      "State Polytechnic Entrance Test",
      "Merit-based admission on 10th marks",
      "Counselling and seat allotment",
      "Document verification",
      "Fee payment and college reporting"
    ],

    topColleges: [
      {
        name: "Government Polytechnic College",
        location: "Chennai",
        fees: "₹15,000",
        ranking: "Government College"
      },
      {
        name: "PSG Polytechnic College",
        location: "Coimbatore",
        fees: "₹50,000",
        ranking: "Private - NAAC A+"
      },
      {
        name: "Sri Krishna Polytechnic College",
        location: "Coimbatore",
        fees: "₹40,000",
        ranking: "Private - Autonomous"
      },
      {
        name: "Government Polytechnic",
        location: "Madurai",
        fees: "₹18,000",
        ranking: "Government College"
      }
    ],

    skills: [
      "Programming Languages",
      "Web Development",
      "Database Management",
      "Network Configuration",
      "System Administration",
      "Software Testing",
      "Problem Solving",
      "Project Management",
      "Technical Documentation",
      "Cybersecurity Basics"
    ],

    futureScope: "Excellent growth prospects with digital transformation, cloud computing, artificial intelligence, and emerging technologies creating high demand for skilled computer technicians.",

    faqs: [
      {
        question: "What's the difference between Computer Engineering Diploma and BCA?",
        answer: "Diploma focuses more on practical technical skills and hardware aspects, while BCA is more application-oriented. Diploma has better hands-on training for immediate employment."
      },
      {
        question: "Can I pursue B.Tech after this diploma?",
        answer: "Yes, you can pursue B.Tech Computer Science or IT through lateral entry (direct 2nd year admission) in most engineering colleges."
      },
      {
        question: "Are there good placement opportunities?",
        answer: "Yes, IT industry has high demand for skilled technicians. Many companies recruit diploma holders for technical support, development, and testing roles."
      },
      {
        question: "Can I work as a freelancer with this qualification?",
        answer: "Absolutely! Skills in web development, programming, and software development are highly valuable for freelancing and starting your own tech business."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default DiplomaComputerEngineeringCoursePage;
